import styled from "@emotion/styled"
import { PInputSearch } from "@porsche-design-system/components-react"
import type { InputSearchInputEventDetail } from "@porsche-design-system/components-react"
import { breakpoint } from "@porsche-design-system/components-react/emotion"
import { useCallback, useState } from "react"
import type { SubmitEventHandler } from "react"
import { defineMessages, useIntl } from "react-intl"

const messages = defineMessages({
	searchInputLabel: {
		defaultMessage: "Enter VIN",
		id: "vinSearchForm.inputLabel",
	},
})

interface VinSearchFormProps {
	defaultValue?: string
	onSubmit: (vin: string) => void
}

export const VinSearchForm = ({ defaultValue, onSubmit }: VinSearchFormProps) => {
	const { formatMessage } = useIntl()
	const [value, setValue] = useState<string>(defaultValue?.toUpperCase() ?? "")

	const onFormSubmit: SubmitEventHandler<HTMLFormElement> = useCallback(
		(e) => {
			e.preventDefault()
			const formData = new FormData(e.currentTarget)
			onSubmit((formData.get("vin") as string).toUpperCase().trim())
		},
		[onSubmit],
	)

	const onInput = useCallback(
		(e: CustomEvent<InputSearchInputEventDetail>) => {
			const newValue = (e.target as HTMLInputElement).value.toUpperCase().trim()
			setValue(newValue)
			if (newValue.length === 17) {
				onSubmit(newValue)
			} else if (newValue.length === 0) {
				onSubmit("") // when field is cleared via ESC key or button
			}
		},
		[onSubmit],
	)

	return (
		<form onSubmit={onFormSubmit}>
			<StyledInputSearch
				name="vin"
				value={value}
				placeholder={formatMessage(messages.searchInputLabel)}
				maxLength={17}
				clear
				indicator
				onInput={onInput}
			/>
		</form>
	)
}

const StyledInputSearch = styled(PInputSearch)`
    @media (min-width: ${breakpoint.s}px) {
        max-width: 285px;
    }
`
